import React from 'react'
const styles = {
  wrapper: { padding: '0 0 24px 35px' },
  warningSign: { padding: '0 4px' },
  bold: { fontWeight: '700' },
}

const WarningLabel = ({ visible, message }) => {
  if (visible) {
    return (
      <div style={styles.wrapper}>
        <span style={styles.warningSign} role="img" aria-label="warning">
          ⚠️
        </span>
        {message}
        <span style={styles.warningSign} role="img" aria-label="warning">
          ⚠️
        </span>
      </div>
    )
  }
  return null
}
export default WarningLabel



// WEBPACK FOOTER //
// ./src/Components/WarningLabel/WarningLabel.js